import Logger from '../logger';

import head from 'lodash/head';
import last from 'lodash/last';
import map from 'lodash/map';
import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import axios from 'axios';

import _decodeTime, { encode as _toMs } from '../filters/time';

import storage from '../helpers/storage.helpers';

const logger = new Logger('HttpService');

const MS_IN_SEC = 1000;

class VTTService {
   get headers() {
      return {
         'Content-Type': 'application/octet-stream',
         authorization : storage.get('guard', 'auth-key')
      };
   }

   async load(path) {
      logger.debug('get vtt from', path);

      try {
         // const { headers } = this;
         // , { headers }
         const resp = await axios.get(path);
         const vtt = await _proccess(resp);
         return _parse(vtt);
      } catch(e) {
         console.error(e);
         return [];
      }
   }
}

function _parse(vtt) {
   let array = vtt.split(/\n\s*\n+/gm);

   const format = array.shift().trim();

   if (format !== 'WEBVTT') {
      logger.error('Incorrect format. Expected WEBVTT. Data: ', vtt);
      return [];
   }

   const timeDelim = '-->';

   return map(filter(array), (str, id) => {
      const lines = str.split(/\n/g);
      const period = lines.shift().split(timeDelim);
      const text = lines.join('\n');
      const fromStr = head(period).trim();
      const toStr = head(last(period).trim().split(' '));
      const from = _toMs(fromStr) * MS_IN_SEC;
      const to = _toMs(toStr) * MS_IN_SEC;

      return { id, from, to, text, changed: false };
   });

}

function _encode(list) {
   return reduce(list, (memo, item) => memo + `\n\n${_encodeItem(item)}`, 'WEBVTT');
}

function _encodeItem({ from, to, text }) {
   return `${_decodeTime(from)} --> ${_decodeTime(to)}\n${text}`;
}

async function _proccess(resp) {
   return isBlob(resp.data) ? blobToString(resp.data) : resp.data;
}

function isBlob(obj) {
   return obj.toString() === '[object Blob]';
}

function blobToString(blob) {
   return new Promise((resolve) => {
      var reader = new FileReader();
      reader.onloadend = function _onloadend() {
         resolve(reader.result);
      };
      reader.readAsText(blob);
   });
}

export default new VTTService();
